import { PhoneDialOutlineIcon } from './PhoneDialOutlineIcon';

/**
 * author: François Risoud
 * id 90BA0013-C6A8-47E9-960C-A1DE13516B25
 * name phone-dial-outline
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/phone-dial-outline.svg
 * tags
 * - Cellphone / Phone 
 */
export const PhoneKeypadOutlineIcon = PhoneDialOutlineIcon;
export default PhoneKeypadOutlineIcon